export default __webpack_public_path__ + "5abe2b69cd3bb97356ef46ba28579fb2.png";